export enum TooltipIcons {
  info = "pi-info-circle",
  question = "pi-question-circle",
}
export enum TooltipPosition {
  top = "top",
  bottom = "bottom",
  left = "left",
  right = "right",
}